import { GetterTree } from 'vuex'
import { SavedFiltersState } from './state'
import { RootState } from '../../state'
import { ResSavedFilter } from '../../../models/users'

export const getters: GetterTree<SavedFiltersState, RootState> = {
  getSavedFilters(state): ResSavedFilter[] {
    return state.filters
  },
  getLastFilter(state): ResSavedFilter | '' {
    return state.newFilter
  }
}
